import { SET_STUDENTS_LIST, SET_PARAMS } from "../mutation-types";

function initState() {
  return {
    students: JSON.parse(localStorage.getItem("report-students-list")) || [],
    paramsCallcenterAdd: {
      campus: {},
    },
  };
}

export default {
  namespaced: true,

  state: initState,

  mutations: {
    [SET_STUDENTS_LIST](state, studentsList) {
      state.students = studentsList;
      localStorage.setItem(
        "report-students-list",
        JSON.stringify(studentsList)
      );
    },
    [SET_PARAMS](state, params) {
      state.paramsCallcenterAdd = Object.assign(
        state.paramsCallcenterAdd,
        params
      );
    },
  },

  actions: {
    setParams({ commit }, params) {
      commit(SET_PARAMS, params);
    },
  },

  getters: {
    paramsCallcenterAdd: (state) => state.paramsCallcenterAdd,
  },
};
